<template>
  <div class="transparent-tab">
    <div class="transparent-tab-btn-up" v-if="!visible">
      <a-button shape="round" icon="caret-up" type="primary" @click="handleOpenOrClose"></a-button>
    </div>
    <div class="transparent-tab-btn-down" v-else>
      <a-button shape="round" icon="caret-down" type="primary" @click="handleOpenOrClose"></a-button>
    </div>
    <div class="transparent-tab-wrapper" v-show="visible">
      <a-tabs :activeKey="activeKey" :animated="false" @change="handleChange">
        <a-tab-pane key="1" :tab="$t('压力计')">
          <div>
            <a-table
              :columns="columns1"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true, y: 120 }"
              size="small"
              @change="handleTableChange"
              :customRow="customRow"
            >
              <template slot="action" slot-scope="text, record">
                <a-button type="primary" size="small" @click="handleViewChart(record)">{{ $t('曲线图') }}</a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('水表')">
          <div>
            <a-table
              :columns="columns2"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true, y: 120 }"
              size="small"
              @change="handleTableChange"
              :customRow="customRow"
            >
              <template slot="action" slot-scope="text, record">
                <a-button type="primary" size="small" @click="handleViewChart(record)">{{ $t('曲线图') }}</a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" :tab="$t('阀门')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true, y: 120 }"
              size="small"
              @change="handleTableChange"
              :customRow="customRow"
            >
              <template slot="action" slot-scope="text, record">
                <a-button type="primary" size="small" @click="handleViewChart(record)">{{ $t('曲线图') }}</a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="4" :tab="$t('消防栓')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true, y: 120 }"
              size="small"
              @change="handleTableChange"
              :customRow="customRow"
            >
              <template slot="action" slot-scope="text, record">
                <a-button type="primary" size="small" @click="handleViewChart(record)">{{ $t('曲线图') }}</a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="5" :tab="$t('水塔')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true, y: 120 }"
              size="small"
              @change="handleTableChange"
              :customRow="customRow"
            >
              <template slot="action" slot-scope="text, record">
                <a-button type="primary" size="small" @click="handleViewChart(record)">{{ $t('曲线图') }}</a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="6" :tab="$t('加压泵')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true, y: 120 }"
              size="small"
              @change="handleTableChange"
              :customRow="customRow"
            >
              <template slot="action" slot-scope="text, record">
                <a-button type="primary" size="small" @click="handleViewChart(record)">{{ $t('曲线图') }}</a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="7" :tab="$t('流量计')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true, y: 120 }"
              size="small"
              @change="handleTableChange"
              :customRow="customRow"
            >
              <template slot="action" slot-scope="text, record">
                <a-button type="primary" size="small" @click="handleViewChart(record)">{{ $t('曲线图') }}</a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="8" :tab="$t('液位计')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true, y: 120 }"
              size="small"
              @change="handleTableChange"
              :customRow="customRow"
            >
              <template slot="action" slot-scope="text, record">
                <a-button type="primary" size="small" @click="handleViewChart(record)">{{ $t('曲线图') }}</a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <div slot="tabBarExtraContent">
          <a-input
            size="small"
            :placeholder="$t('请输入节点代码或名称')"
            v-model="model.name"
            @pressEnter="searchQuery"
          ></a-input>
        </div>
      </a-tabs>
    </div>
    <LineGraphModal ref="LineGraphModalRef"/>
  </div>
</template>
      
  <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import vueSeamlessScroll from 'vue-seamless-scroll'
import JInput from '../../../../components/jeecg/JInput.vue'
import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
import Vue from 'vue'
import LineGraphModal from './LineGraphModal.vue'
export default {
  name: 'modal',
  components: {
    vueSeamlessScroll,
    JInput,
    LineGraphModal
  },
  data() {
    return {
      title: this.$t('组件2'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      url: {
        pageNode: '/jeecg-gis/topology/node/pageNode',
        pagePipeline: '/jeecg-gis/topology/pipeline/pagePipeline',
        getUsedTopology: '/jeecg-gis/topology/topology/getUsedTopology',
      },
      activeKey: '1',
      list: [],
      loading: false,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '15'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' ' + this.$t('共{total}条', { total })
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      versionForm: {},
      // type: {
      //   1: 'NODE_PIPELINE_TYPE_VALVE',
      //   2: 'NODE_PIPELINE_TYPE_HYDRANT',
      //   3: 'NODE_PIPELINE_TYPE_TOWER',
      //   4: 'NODE_PIPELINE_TYPE_BOOSTER_PUMP_STATION',
      //   5: 'NODE_PIPELINE_TYPE_METER',
      //   6: 'NODE_PIPELINE_TYPE_COMMON',
      //   7: 'NODE_PIPELINE_TYPE_PIPELINE',
      // },
      type: {
        1: 'NODE_PIPELINE_TYPE_PM',//压力计
        2: 'NODE_PIPELINE_TYPE_METER',//水表
        3: 'NODE_PIPELINE_TYPE_VALVE',//阀门
        4: 'NODE_PIPELINE_TYPE_HYDRANT',//消防栓
        5: 'NODE_PIPELINE_TYPE_TOWER',//水塔
        6: 'NODE_PIPELINE_TYPE_BOOSTER_PUMP_STATION',//加压泵
        7: 'NODE_PIPELINE_TYPE_FM',//流量计
        8: 'NODE_PIPELINE_TYPE_WM',//液位计
      },
      currentRow: {},
    }
  },
  computed: {
    columns1() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('代码'),
          align: 'center',
          dataIndex: 'code',
          customRender: (t, r, index) => {
            return r.node && r.node.code
          },
        },
        {
          title: this.$t('名称'),
          align: 'center',
          dataIndex: 'name',
          customRender: (t, r, index) => {
            return r.node && r.node.name
          },
        },
        {
          title: this.$t('类型'),
          align: 'center',
          dataIndex: 'type',
          customRender: (t, r, index) => {
            return r.node && filterDictTextByCache('node_type', r.node.type)
          },
        },
        {
          title: this.$t('物联代码'),
          align: 'center',
          dataIndex: 'deviceId',
          customRender: (t, r, index) => {
            return r.nodeIotConfig && r.nodeIotConfig.deviceId
          },
        },
        {
          title: this.$t('转换系数'),
          align: 'center',
          dataIndex: 'conversionCoefficient',
          customRender: (t, r, index) => {
            return r.nodeIotConfig && r.nodeIotConfig.conversionCoefficient
          },
        },
        {
          title: this.$t('压力'),
          align: 'center',
          dataIndex: 'pvalue',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.pvalue
          },
        },
        {
          title: this.$t('温度'),
          align: 'center',
          dataIndex: 'tepvalue',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.tepvalue
          },
        },
        {
          title: this.$t('电压'),
          align: 'center',
          dataIndex: 'battery',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.battery
          },
        },
        {
          title: this.$t('信号'),
          align: 'center',
          dataIndex: 'signDb',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.signDb
          },
        },
        {
          title: this.$t('最新上报时间'),
          align: 'center',
          dataIndex: 'metertime',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.metertime
          },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    columns2() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('代码'),
          align: 'center',
          dataIndex: 'code',
          customRender: (t, r, index) => {
            return r.node && r.node.code
          },
        },
        {
          title: this.$t('名称'),
          align: 'center',
          dataIndex: 'name',
          customRender: (t, r, index) => {
            return r.node && r.node.name
          },
        },
        {
          title: this.$t('类型'),
          align: 'center',
          dataIndex: 'type',
          customRender: (t, r, index) => {
            return r.node && filterDictTextByCache('node_type', r.node.type)
          },
        },
        {
          title: this.$t('表编号'),
          align: 'center',
          dataIndex: 'meterId',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterId
          },
        },
        {
          title: this.$t('累计用量'),
          align: 'center',
          dataIndex: 'meterTotalUse',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterTotalUse
          },
        },
        {
          title: this.$t('结算日流量'),
          align: 'center',
          dataIndex: 'meterJsrUse',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterJsrUse
          },
        },
        {
          title: this.$t('表端剩余金额'),
          align: 'center',
          dataIndex: 'meterRemainNum',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterRemainNum
          },
        },
        {
          title: this.$t('电压'),
          align: 'center',
          dataIndex: 'meterBatteryVoltage',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterBatteryVoltage
          },
        },
        {
          title: this.$t('信号'),
          align: 'center',
          dataIndex: 'meterSignalStrength',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterSignalStrength
          },
        },
        {
          title: this.$t('最新上报时间'),
          align: 'center',
          dataIndex: 'sysTime',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.sysTime
          },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        { title: this.$t('编码'), dataIndex: 'code', align: 'center',width: 100 },
        { title: this.$t('名称'), dataIndex: 'name', align: 'center' },
        {
          title: this.$t('类型'),
          dataIndex: 'type',
          align: 'center',
          customRender: (t, r, index) => {
            if(t == 'NODE_PIPELINE_TYPE_PIPELINE'){
              return this.$t('管道');
            }else{
              return filterDictTextByCache('node_type',t)
            }
          }
        },
        { title: this.$t('高程'), dataIndex: 'height', align: 'center' },
        { title: this.$t('上报数据'), dataIndex: 'value', align: 'center', customRender: (t, r, index) => {
          if(r.iotData){
            return r.iotData.value
          }else{
            return '-'
          }
        } },
        { title: this.$t('上报时间'), dataIndex: 'lastUpdateTime', align: 'center', customRender: (t, r, index) => {
          if(r.iotData){
            return r.iotData.lastUpdateTime
          }else{
            return '-'
          }
        } },
        {
          title: this.$t('操作'),
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width: 120
        }
      ]
    },
    pipeColumns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        { title: this.$t('编码'), dataIndex: 'code', align: 'center',width: 100 },
        { title: this.$t('名称'), dataIndex: 'name', align: 'center' },
        {
          title: this.$t('类型'),
          dataIndex: 'type',
          align: 'center',
          customRender: (t, r, index) => {
            if(t == 'NODE_PIPELINE_TYPE_PIPELINE'){
              return this.$t('管道');
            }else{
              return filterDictTextByCache('node_type',t)
            }
          }
        },
        { title: this.$t('高程'), dataIndex: 'height', align: 'center' },
        { title: this.$t('材质'), dataIndex: 'materialType', align: 'center' },
        { title: this.$t('管径'), dataIndex: 'diameter', align: 'center' },
        { title: this.$t('管长'), dataIndex: 'length', align: 'center' },
        { title: this.$t('上报数据'), dataIndex: 'value', align: 'center', customRender: (t, r, index) => {
          if(r.iotData){
            return r.iotData.value
          }else{
            return '-'
          }
        } },
        { title: this.$t('上报时间'), dataIndex: 'lastUpdateTime', align: 'center', customRender: (t, r, index) => {
          if(r.iotData){
            return r.iotData.lastUpdateTime
          }else{
            return '-'
          }
        } },
        {
          title: this.$t('操作'),
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width: 120
        }
      ]
    },
  },
  mounted() {
    this.versionForm = Vue.ls.get('GIS_TOPOLOGY_DATA').topology;
    this.getNodeData(this.type[this.activeKey])
  },
  methods: {
    searchQuery() {
      this.ipagination.current = 1
      if (this.activeKey == 7) {
        this.getLineData(this.type[this.activeKey])
      } else {
        this.getNodeData(this.type[this.activeKey])
      }
    },
    handleChange(e) {
      this.activeKey = e
      this.dataSource = []
      this.ipagination.current = 1
      this.ipagination.total = 0
      this.getNodeData(this.type[this.activeKey])
      // 管线
      // if (e == 7) {
      //   this.getLineData(this.type[this.activeKey])
      // } else {
      //   this.getNodeData(this.type[this.activeKey])
      // }
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.getNodeData(this.type[this.activeKey])
      // if (this.activeKey == 7) {
      //   this.getLineData(this.type[this.activeKey])
      // } else {
      //   this.getNodeData(this.type[this.activeKey])
      // }
    },
    customRow(record, index) {
      return {
        on: {
          click: e => {
            this.currentRow = record;
            this.$emit('handleLocation',this.currentRow);
          },
        },
      }
    },
    // 节点
    getNodeData(type) {
      let params = {
        projectCode: this.versionForm.projectCode,
        topologyCode: this.versionForm.code,
        name: this.model.name,
        type: type,
        page: {
          current: this.ipagination.current,
          size: this.ipagination.pageSize,
        },
      }
      postAction(this.url.pageNode, params).then(res => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 管线
    getLineData(type) {
      let params = {
        projectCode: this.versionForm.projectCode,
        topologyCode: this.versionForm.code,
        name: this.model.name,
        type: type,
        page: {
          current: this.ipagination.current,
          size: this.ipagination.pageSize,
        },
      }
      postAction(this.url.pagePipeline, params).then(res => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleOpenOrClose() {
      this.visible = !this.visible
    },
    handleViewChart(record){
      this.$refs.LineGraphModalRef.init(record);
    }
  },
}
</script>
  <style lang="less" scoped>
.transparent-tab {
  width: 100%;
  position: absolute;
  bottom: 590px;
}
.transparent-tab-wrapper {
  height: 240px;
  width: 100%;
  position: absolute;
  right: 0;
  left: 0;
  bottom: -600px;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
.transparent-tab-btn-up {
  width: 100%;
  height: 40px;
  position: absolute;
  right: 0;
  left: 0;
  bottom: -600px;
  z-index: 999;
  text-align: center;
}
.transparent-tab-btn-down {
  width: 100%;
  height: 40px;
  position: absolute;
  right: 0;
  left: 0;
  bottom: -360px;
  z-index: 999;
  text-align: center;
}
::v-deep .ant-tabs-bar {
  margin: 0;
}
::v-deep .ant-tabs-nav-container {
  color: #fff;
  background: rgba(70, 76, 92, 0.8);
  margin-top: 0;
  border-radius: 6px 0 0 0;
}
::v-deep .ant-tabs-extra-content {
  background: rgba(70, 76, 92, 0.8);
  border-radius: 0 6px 0 0;
  padding-right: 10px;
}
::v-deep .ant-tabs-tabpane {
  //   padding: 10px;
}
.ant-tabs {
  color: #fff;
}
::v-deep .ant-tabs-nav-container {
  line-height: 1.6;
}
::v-deep .ant-table-thead > tr > th {
  color: #fff;
  background-color: rgba(70, 76, 92, 0.5) !important;
}
::v-deep .ant-table-tbody > tr > td {
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border: none;
}
::v-deep .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
::v-deep .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
::v-deep .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
::v-deep .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: rgba(0, 0, 0, 0.5);
}
::v-deep .ant-table-body {
  overflow: auto !important;
}
::v-deep .ant-table-placeholder {
  background: transparent;
  .ant-empty-normal {
    color: #fff;
  }
}
::v-deep .ant-table-pagination.ant-pagination {
  margin: 5px 0;
}
::v-deep .ant-pagination,
::v-deep .ant-pagination-item a {
  color: #fff;
}
::v-deep .ant-pagination-item-active a {
  color: #1890ff;
}
::v-deep .ant-btn-primary{
  background-color: rgba(70, 76, 92, 0.8);
  border-color: rgba(70, 76, 92, 0.8);
}
</style>